import {initAccordion} from './view';

const init = () => {
    if (document.body.classList.contains('wp-admin')) return;
    document.querySelectorAll<HTMLElement>('[data-art-accordion]').forEach(initAccordion);
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
